import { useEffect } from 'react';

const API_BASE = process.env.REACT_APP_API_URL || 'https://api.bookyatri.com/api';

function getImageUrl(path) {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  if (path.startsWith('/storage/')) return 'https://api.bookyatri.com' + path;
  return path;
}

function getPortalFromPath() {
  const path = window.location.pathname;
  if (path.startsWith('/admin')) return 'admin';
  if (path.startsWith('/partner')) return 'partner';
  if (path.startsWith('/agent')) return 'agent';
  if (path.startsWith('/corporate')) return 'corporate';
  return 'user';
}

const PORTAL_DOMAINS = {
  admin: 'admin.bookyatri.com',
  partner: 'partner.bookyatri.com',
  agent: 'agent.bookyatri.com',
  corporate: 'corporate.bookyatri.com',
  user: 'bookyatri.com'
};

export default function PortalFavicon() {
  useEffect(() => {
    const portal = getPortalFromPath();
    const domain = PORTAL_DOMAINS[portal] || 'bookyatri.com';

    fetch(API_BASE + '/settings/website/' + domain)
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (!data || !data.success || !data.data) return;
        const favicon = data.data.content?.favicon;
        if (favicon) {
          const url = getImageUrl(favicon) + '?v=' + Date.now();
          const existing = document.querySelector('link[rel="icon"]');
          if (existing) existing.href = url;
          else {
            const link = document.createElement('link');
            link.rel = 'icon';
            link.href = url;
            document.head.appendChild(link);
          }
        }
      })
      .catch(() => {});
  }, []);

  return null;
}
